import React from "react";
import { Modal, Form } from "react-bootstrap";
import { value } from "lodash/seq";

class RangePicker extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            value: props.amount,
            show: false
        };
    }

    show() {
        this.setState({ show: true });
    }

    handleClose() {
        //MUST USE SET TIMEOUT. WHY??????????
        setTimeout(() => {
            this.setState({ show: false });
            this.props.rangeChanged(this.state.value);
        }, 1);
    }

    neutralize() {
        //MUST USE SET TIMEOUT. WHY??????????
        setTimeout(() => {
            this.setState({ show: false });
            this.props.rangeChanged(0);
        }, 1);
    }

    render() {
        return (
            <Modal
                style={{ width: "90%", margin: "5% auto", right: 0, left: 0 }}
                show={this.state.show}
                centered
                onHide={this.handleClose.bind(this)}
            >
                <Modal.Header closeButton>
                    <h2>פרטי עסקה</h2>
                    {/*<Modal.Title dir={"rtl"} style={{dir: "rtl"}}>פרטים</Modal.Title>*/}
                </Modal.Header>
                <Modal.Body>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                        <div dir={"rtl"}>
                            <Form.Label>{this.props.data.description}</Form.Label>
                        </div>
                        <div dir={"rtl"}>
                            <Form.Label>{this.props.data.remarks}</Form.Label>
                        </div>
                        <div dir={"rtl"}>
                            <Form.Label>{this.props.data.time}</Form.Label>
                        </div>
                        <div dir={"rtl"}>
                            <Form.Label>סכום: {this.state.value}</Form.Label>
                        </div>
                        <div dir={"rtl"} style={{ display: "flex", flexDirection: "column" }}>
                            <button style={{ width: "100px" }} onClick={this.neutralize.bind(this)}>
                                נטרל עסקה
                            </button>
                        </div>
                        שנה סכום
                        <Form.Range
                            value={this.state.value}
                            min={0}
                            max={this.props.max}
                            onChange={(event) => this.setState({ value: event.target.value })}
                        />
                    </div>
                </Modal.Body>
            </Modal>
        );
    }
}

export default RangePicker;
